import React from 'react';

const CookiePolicy = () => {
    return (
        <div className="pt-24 sm:pt-28 md:pt-36 pb-16 px-4 sm:px-6 md:px-12 lg:px-20 max-w-5xl mx-auto">
            <h1 className="tracking-wide font-thin md:font-light text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-gray-900 mb-8 sm:mb-12">
                COOKIE POLICY
            </h1>
            <div className="space-y-8 text-gray-700 leading-relaxed text-sm sm:text-base">
                <div className="pb-4">
                    <p>
                        At Haideries Real Estate, we prioritize your privacy and data protection. To enhance your experience on our website, we utilize cookies and similar technologies. This cookie policy outlines our use of these technologies and provides information on how you can control or opt out of them.
                    </p>
                </div>

                <div className="pb-4">
                    <h2 className="text-base sm:text-lg font-bold text-gray-900 mb-3">What are Cookies?</h2>
                    <p>
                        Cookies are small text files downloaded to your computer or device when you visit a website. They collect data about your interactions with the website, such as preferences, browsing history, and settings, to personalize content and improve overall user experience.
                    </p>
                </div>

                <div className="pb-4">
                    <h2 className="text-base sm:text-lg font-bold text-gray-900 mb-3">Types of Cookies</h2>
                    <ul className="list-disc pl-5 space-y-2">
                        <li><span className="font-semibold text-gray-900">Essential Cookies:</span> Necessary for the website to function, including session and security cookies.</li>
                        <li><span className="font-semibold text-gray-900">Performance Cookies:</span> Track website usage, improving performance, speed, and functionality.</li>
                        <li><span className="font-semibold text-gray-900">Functionality Cookies:</span> Keep track of preferences like language and location, enhancing your experience.</li>
                        <li><span className="font-semibold text-gray-900">Targeting/Advertising Cookies:</span> Monitor browsing habits to deliver personalized advertising and assess marketing success.</li>
                    </ul>
                </div>

                <div className="pb-4">
                    <h2 className="text-base sm:text-lg font-bold text-gray-900 mb-3">Cookie Management</h2>
                    <p>
                        You can control or disable cookies through your web browser settings. However, please note that enabling cookies may impact the functionality and effectiveness of the website.
                    </p>
                </div>

                <div className="pb-4">
                    <h2 className="text-base sm:text-lg font-bold text-gray-900 mb-3">Privacy Protection</h2>
                    <p>
                        We prioritize the security of your privacy and data. We do not collect or utilize personal information through cookies without your consent. Additionally, data collected by our cookies is not shared with third parties for marketing purposes.
                    </p>
                </div>

                <div className="pb-4">
                    <h2 className="text-base sm:text-lg font-bold text-gray-900 mb-3">Modifications to this Policy</h2>
                    <p>
                        We may update this cookie policy to reflect changes in our use of cookies and related technologies. Regularly reviewing our policy will keep you informed of any updates.
                    </p>
                </div>

                <div className="pb-4">
                    <h2 className="text-base sm:text-lg font-bold text-gray-900 mb-3">Contact Us</h2>
                    <p>
                        If you have questions or concerns about our use of cookies, please email us at{' '}
                        <a href="mailto:info@haideries.ae" className="text-blue-600 hover:underline">
                            info@haideries.ae
                        </a>.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default CookiePolicy;
